export class InsertionPointConfig {
  public static label_backgroundColor = 'rgba(255, 255, 0, 0.6)';
  public static label_fontColor = '#ffffff';
}
